import React from 'react';
import { Helmet } from 'react-helmet';

const Profile = () => {
  const buildDate = new Date().toISOString();

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'ProfilePage',
          dateCreated: '2024-08-10T12:34:00-05:00',
          dateModified: buildDate,
          mainEntity: {
            '@type': 'Person',
            name: 'Daniel Bechenea',
            alternateName: 'danielbechenea',
            description: 'Product Security Manager and OSCP Certified Penetration Tester',
            image: 'https://danielbechenea.com/daniel.jpg',
            url: 'https://danielbechenea.com',
            jobTitle: 'Product Security Manager',
            worksFor: {
              '@type': 'Organization',
              name: 'Pentest-Tools.com',
              url: 'https://pentest-tools.com',
            },
            sameAs: ['https://www.linkedin.com/in/danielbechenea/'],
          },
        })}
      </script>
    </Helmet>
  );
};

export default Profile;
